<template lang='pug' src='./HotspotConnections.pug'></template>

<script>
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
import { localize } from 'vee-validate'
import { buildPayloadPagination } from '@/utils/utils.js'

import ClientProfile from '@/components/clients/ClientProfile.vue'

import pt_BR from "vee-validate/dist/locale/pt_BR.json";
import en from "vee-validate/dist/locale/en.json";
import es from "vee-validate/dist/locale/es.json";

export default {
  data() {
    return {
      blockDialog: false,
      vipDialog: false,
      blockItem: [],
      vipItem: [],
      dialog: false,
      clientItem: [],
      ranking: false,
      nome: '',
      os: '',
      defaultItem: {
        nome: '',
        os: '',
        inicio: '',
        duracao: '',
        conexoes: ''
      },
      searchInput: '',
      dataTableLoading: true,
      delayTimer: null,
      search: '',
      //defaultItem: {},
      pagination: {
        identity: window.localStorage.getItem('selectedHotspot').split('"').join(''),
        sortBy: ['nome'],
        sortDesc: ['true']},
      fieldsToSearch: ['nome', 'os'],
      isEditing: false
    }
  },
  components: {
    ClientProfile
  },
  methods: {
    ...mapGetters(['isTokenSet']),
    ...mapActions(['getConnections', 'getRanking', 'getClientProfile', 'blockUserAccess','makeDeviceVip']),
    confirmVip(item){
      this.vipItem = item
      this.vipDialog = true
    },
    confirmBlock(item){
      this.blockItem = item
      this.blockDialog = true
    },
    async vipUser(){
      this.vipDialog = false
      var vip = true
      if(this.vipItem.vip){ // se já estiver bloqueado, desbloqueia
        vip = false
      }
      await this.makeDeviceVip({
        identity: window.localStorage.getItem('selectedHotspot').split('"').join(''),
        userId: this.vipItem.user._id,
        vip: vip
      })
      this.doSearch()
    },
    async blockUser(){
      this.blockDialog = false
      var block = true
      if(this.blockItem.blocked){ // se já estiver bloqueado, desbloqueia
        block = false
      }
      await this.blockUserAccess({
        identity: window.localStorage.getItem('selectedHotspot').split('"').join(''),
        userId: this.blockItem.user._id,
        block: block
      })
      this.doSearch()
    },
    async showDialog(id){
      // this.showSimpleLoading = true
      await this.getClientProfile({
        _id: id
      })
      this.clientItem = this.$store.state.adminClients.client
      this.dialog=true
      // this.showSimpleLoading = false
    },
    closeDialog(){
      this.dialog = false
    },
    showRanking(){
      this.ranking = !this.ranking
      this.doSearch()
    },
    async doSearch() {
      this.pagination.identity = window.localStorage.getItem('selectedHotspot').split('"').join('')

      try {
        this.dataTableLoading = true

        if(this.ranking){
          await this.getRanking(
            buildPayloadPagination(this.pagination, this.buildSearch())
          )
        }else{
          await this.getConnections(
            buildPayloadPagination(this.pagination, this.buildSearch())
          )
        }

        this.dataTableLoading = false
        // eslint-disable-next-line no-unused-vars
      } catch (error) {
        this.dataTableLoading = false
      }
    },
    buildSearch() {
      console.log('Search: '+this.search
        ? { query: this.search, fields: this.fieldsToSearch.join(',') }
        : {})
      return this.search
        ? { query: this.search, fields: this.fieldsToSearch.join(',') }
        : {}
    }
  },
  computed: {
    //...mapGetters(['connection']),
    headers() {
      if(this.ranking){ // ranking
        return [
          {
            text: `${this.$t('adminconnections.TABLEUSERNAME')}`,
            align: 'left',
            value: 'user.nome',
          },
          { text: `${this.$t('adminconnections.TABLEUSERDEVICE')}`, value: 'user.os' },
          { text: `${this.$t('adminconnections.TABLESTART')}`, value: 'inicio' },
          { text: `${this.$t('adminconnections.TABLECONNECTIONS')}`, value: 'daysConns' }
        ]
      }else{ // ordem normal
        return [
          {
            text: `${this.$t('adminconnections.TABLEUSERNAME')}`,
            align: 'left',
            value: 'user.nome',
          },
          { text: `${this.$t('adminconnections.TABLEUSERDEVICE')}`, value: 'os' },
          { text: `${this.$t('adminconnections.TABLESTART')}`, value: 'inicio' },
          { text: `${this.$t('adminconnections.TABLEDURATION')}`, value: 'duracao' },
          { text: `${this.$t('adminconnections.TABLEACTIONS')}`, value: 'actions' }
        ]
      }
    },

    lang(){
      return this.$store.getters.locale
    },
    items() {
      return this.$store.state.adminConnections.connections
    },
    totalItems() {
      return this.$store.state.adminConnections.totalConnections
    },
    selectedHs () {
      return this.$store.state.adminHotspots.selectedHotspot
    }
  },
  watch: {

    selectedHs () {
      this.doSearch()
    },
    lang (newLang) { // se trocou a linguagem, revalida o form
      const lg = { en: en, pt: pt_BR, es: es };
      localize(`${newLang}`, lg[newLang]);
    },

    pagination: {
    async handler() {
      try {
        this.dataTableLoading = true

        if(this.ranking){
          await this.getRanking(
            buildPayloadPagination(this.pagination, this.buildSearch())
          )
        }else{
          await this.getConnections(
            buildPayloadPagination(this.pagination, this.buildSearch())
          )
        }

        this.dataTableLoading = false
        // eslint-disable-next-line no-unused-vars
      } catch (error) {
        this.dataTableLoading = false
      }
    },
    deep: true
  },
  search() {
    clearTimeout(this.delayTimer)
    this.delayTimer = setTimeout(() => {
      this.doSearch()
    }, 400)
  }
  }
}
</script>
